module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-italic.var.woff2?b14d906b50e8d375056daee974b650d9";